import React from 'react';
import { Slide as SlideType } from '@/eventConfig/types.ts';
import { ConfirmDataEntryCheckbox } from '@/components/slides/DataSummary/components/ConfirmDataEntryCheckbox.tsx';
import { ConfigSlideId } from '@/eventConfig/types.ts';

export const ConfirmDataEntryCheckboxIN = ({ slide }: { slide: SlideType }) => {
  const slideIdsToValidate: ConfigSlideId[] = [
    'name',
    'email',
    'phone',
    'address',
    'birthdate',
    'bmi',
    'ancestry',
    'contactPersons',
  ];
  return <ConfirmDataEntryCheckbox slide={slide} slideIdsToValidate={slideIdsToValidate} />;
};
